import { jsxs, jsx } from "react/jsx-runtime";
import { BodySpacer } from "./BodySpacer.js";
function Body({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsxs("tbody", {
    ...props,
    children: [/* @__PURE__ */ jsx(BodySpacer, {}), children, /* @__PURE__ */ jsx(BodySpacer, {})]
  });
}
export {
  Body
};
//# sourceMappingURL=Body.js.map
